import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  DvDynamicFormElement,
  DvDynamicFormModule,
  DvFormUtils,
  DvRadioGroupLegacyElement,
  FormOf,
} from '@devinco/ui/legacy';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FindUpdateAction } from '@pages/assets-page/components/constants';
import { AssetFindUpdateDialogData } from '@pages/assets-page/components/interfaces';
import { PipesModule } from '@shared/pipes/pipes.module';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
} from '@devinco/ui/dds';
import { DvAlertBannerComponent } from '@devinco/ui/dds/alert-banner';

@Component({
  selector: 'app-update-asset-find-dialog',
  templateUrl: './update-asset-find-dialog.component.html',
  styleUrls: ['./update-asset-find-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    PipesModule,
    DvDynamicFormModule,
    TranslateModule,
    DvAlertBannerComponent,
    DvDialogContentComponent,
    DvButtonComponent,
  ],
})
export class UpdateAssetFindDialogComponent
  extends DvDialogContent<
    AssetFindUpdateDialogData,
    UpdateAssetFindDialogComponent
  >
  implements OnInit
{
  private translate = inject(TranslateService);

  elements: DvDynamicFormElement[];
  formGroup: FormGroup<FormOf<{ deleteActionId: FindUpdateAction }>>;

  ngOnInit(): void {
    this.setFormElements();
    this.setupForm();
  }

  cancel(): void {
    this.dialogRef!.onClose(undefined, 'cancel');
  }

  confirm(): void {
    this.dialogRef!.onClose(this.formGroup.value.deleteActionId, 'confirm');
  }

  private setFormElements(): void {
    this.elements = [
      new DvRadioGroupLegacyElement({
        colspan: 12,
        key: 'deleteActionId',
        direction: 'horizontal',
        labelKey: 'label',
        valueKey: 'value',
        infoTextKey: 'description',
        items: Object.keys(FindUpdateAction).map(action => ({
          label: this.translate.instant(`Asset.DeleteDialog.${action}`),
          value: action,
          description: this.translate.instant(
            `Asset.${this.data.dialogType}.Info.${action}`
          ),
        })),
        gridSize: 1,
        rowspan: 1,
      }),
    ];
  }

  private setupForm(): void {
    this.formGroup = DvFormUtils.createFormGroup(this.elements);
    this.formGroup.setValue({
      deleteActionId: FindUpdateAction.DeactivateFind,
    });
  }
}
